import gql from "graphql-tag";

export default gql`
  query getBloomberg($query: BloombergQuery!) {
    getBloomberg(query: $query)
  }
`;
